module.exports = __webpack_public_path__ + "img/2.a4500a01.jpg";